import { SINGAPORE_PHONE_LENGTH } from './constants';

export const getCountryCode = str => {
  if (str && !str.includes('+')) {
    return `+${str}`;
  }
  return str;
};

export const validateSingaporePhoneFormat = (
  isSingaporeCountryCode,
  phoneNo
) => {
  let onlyNums = phoneNo.replace(/[^0-9]/g, '');

  if (isSingaporeCountryCode && onlyNums.length > SINGAPORE_PHONE_LENGTH) {
    onlyNums = onlyNums.substring(0, SINGAPORE_PHONE_LENGTH);
  }

  return onlyNums;
};

export default { getCountryCode, validateSingaporePhoneFormat };
